// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"63":"71c42ca9","379":"1d84b24a","545":"488bc451","589":"c067b35f","594":"44881b1f","666":"cc0c8747","815":"96951182","906":"3695c61b","922":"ac34c574","997":"9c96d7c7"}[chunkId] + ".css";
};